import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function alphanumericValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const hasAlphanumeric = /[a-zA-Z0-9]/.test(value); // RegEx für alphanumerische Zeichen
    
    return hasAlphanumeric ? null : { 'alphanumericRequired': true };
  };
}
